import { useRealtime } from '@/stores/realtime';

const LABELS: Record<string, string> = {
  idle: 'Realtime off',
  connecting: 'Connecting',
  open: 'Live',
  closed: 'Reconnecting',
};

export function ConnectionStatus() {
  const state = useRealtime((s) => s.connection);
  const resyncNeeded = useRealtime((s) => s.resyncNeeded);

  return (
    <span className="conn" data-state={state} title="Realtime event stream">
      <span className="conn-dot" aria-hidden />
      <span>{LABELS[state] ?? state}</span>
      {resyncNeeded && <span className="hint">· refreshing</span>}
    </span>
  );
}
